/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_BeforeInputs */

const en_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Before`)
};

const fr_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement avant`)
};

const de_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorher`)
};

const it_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento prima`)
};

const ru_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие до`)
};

const es_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

const zh_cn2_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件发生前`)
};

const ja_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント前`)
};

const hi_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इससे पहले की घटना`)
};

const pt_pt2_event_before = /** @type {(inputs: Event_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento anterior`)
};

/**
* | output |
* | --- |
* | "Event Before" |
*
* @param {Event_BeforeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_before = /** @type {((inputs?: Event_BeforeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_BeforeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_before(inputs)
	if (locale === "de") return de_event_before(inputs)
	if (locale === "it") return it_event_before(inputs)
	if (locale === "ru") return ru_event_before(inputs)
	if (locale === "es") return es_event_before(inputs)
	if (locale === "zh-CN") return zh_cn2_event_before(inputs)
	if (locale === "ja") return ja_event_before(inputs)
	if (locale === "hi") return hi_event_before(inputs)
	if (locale === "pt-PT") return pt_pt2_event_before(inputs)
	return en_event_before(inputs)
});